import { ValidationIcon_default } from "./chunk-LZGR2HFH.js";
import { InputComponent } from "./chunk-OADWJROU.js";
import { Spinner_default } from "./chunk-6KCFYSFL.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Select/Select.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var Select = forwardRef((_a, ref) => {
  var _b = _a,
    {
      variant = "secondary",
      disabled,
      validation,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["variant", "disabled", "validation", "isLoading", "className"]);
  return /* @__PURE__ */React.createElement(InputComponent, {
    variant,
    validation: variant === "secondary" ? validation : void 0,
    disabled,
    className: clsx("pd-select", isLoading && "pd-select--loading", variant === "secondary" && validation && "pd-select--validation", className)
  }, /* @__PURE__ */React.createElement(InputComponent.Input, __spreadValues({
    ref,
    as: "select",
    isLoading,
    className: "pd-select__input"
  }, rest)), variant === "secondary" && validation && !isLoading && /* @__PURE__ */React.createElement(InputComponent.Icon, null, /* @__PURE__ */React.createElement(ValidationIcon_default, {
    variant: validation
  })), isLoading && /* @__PURE__ */React.createElement(InputComponent.Icon, null, /* @__PURE__ */React.createElement(Spinner_default, {
    variant: "primary"
  })));
});
var Select_default = Select;
export { Select_default };